import React, { useRef } from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import Header from './components/sections/Header';
import HeroSection from './components/sections/HeroSection';
import ContextSection from './components/sections/ContextSection';
import ObjectiveSection from './components/sections/ObjectiveSection';
import WhatIsSection from './components/sections/WhatIsSection';
import EmbarqueFlowSection from './components/sections/EmbarqueFlowSection';
import FeaturesSection from './components/sections/FeaturesSection';
import PhasesSection from './components/sections/PhasesSection';
import PricingSection from './components/sections/PricingSection';
import TestimonialsSection from './components/sections/TestimonialsSection';
import DemoFormSection from './components/sections/DemoFormSection';
import FinalSection from './components/sections/FinalSection';
import Footer from './components/sections/Footer';

function App() {
  const demoFormRef = useRef(null);

  const handleScheduleDemo = () => {
    const element = document.getElementById('agendar-demo');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      
      <Header onScheduleDemo={handleScheduleDemo} />
      
      <main>
        <HeroSection onScheduleDemo={handleScheduleDemo} />
        <ContextSection />
        <ObjectiveSection />
        <WhatIsSection />
        <EmbarqueFlowSection />
        <FeaturesSection />
        <PhasesSection />
        <PricingSection />
      {/* <TestimonialsSection /> */}
        <DemoFormSection ref={demoFormRef} />
        <FinalSection onScheduleDemo={handleScheduleDemo} />
      </main>
      
      <Footer />
    </div>
  );
}

export default App;
